import { defineMessages } from "react-intl";

import {
	hasOrganTransplantationMessages,
	organTransplantationMessages,
	validator
} from "lib/build/forms/ktx/basic-registration-data/clinical-data/pre-immunisation/combinedOrganTransplantation";

import { FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	combinedOrganTransplantation: {
		id: "ktx.form.combined_organ_transplantation.title",
		defaultMessage: "Kombinált szervtranszplantáció"
	},
	hasOrganTransplantation: {
		id: "ktx.form.combined_organ_transplantation.hasOrganTransplantation",
		defaultMessage: "Kombinált szervtranszplantáció?"
	},
	organTransplantation: {
		id: "ktx.form.combined_organ_transplantation.value",
		defaultMessage: "Kombinált transzplantációs javaslat"
	}
});

const fieldset: FieldsetData = {
	rows: [
		{
			columns: [
				{
					width: 12,
					field: {
						type: "field",
						path: ["hasOrganTransplantation"],
						label: messages.hasOrganTransplantation,
						errorMessages: genericErrorMessages,
						input: {
							type: "button-group",
							props: {
								labels: hasOrganTransplantationMessages
							}
						}
					}
				}
			]
		},
		{
			columns: [
				{
					width: 12,
					field: {
						type: "field",
						path: ["organTransplantation"],
						label: messages.organTransplantation,
						errorMessages: genericErrorMessages,
						input: {
							type: "checkbox-group",
							props: {
								labels: organTransplantationMessages,
								direction: "vertical",
								columns: 2
							}
						}
					}
				}
			]
		}
	]
};

export const node: LeafNode = {
	id: "ktx_combinedOrganTransplantation",
	value: {
		schemaId: "combinedOrganTransplantation",
		title: messages.combinedOrganTransplantation,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
